import {toISODate, toInt, toDecimal} from "../../../../utils/convert-fields"
import {formatDateBr} from "../../../../utils/convert-fields"

export const conversibilidadeFields = [
    { key: "DataReferencia", label: "Data Referência" },
    { key: "PrecoConversao", label: "Preço Conversão" },
    { key: "PremioConversao", label: "Prêmio Conversão" },
    { key: "DataInicioPreco", label: "Data Início Preço" },
    { key: "Ticker", label: "Ticker" },
    { key: "ConversaoFacultativa", label: "Conversão Facultativa" },
    { key: "ConversaoMandatoria", label: "Conversão Mandatória" },
    { key: "DataInicioConversao", label: "Data Início Conversão" },
    { key: "DataFimConversao", label: "Data Fim Conversão" },
    { key: "LimiteConversao", label: "Limite Conversão" },
    { key: "TipoPrecoConversao", label: "Tipo Preço Conversão" },
    { key: "JanelaPregoes", label: "Janela Pregões" },
    { key: "PercentualPregoes", label: "Percentual Pregões" },
]

export const mapConversibilidadePayload = (
    tableData = [],
    idCaracteristica
) => {
    const conversibilidades = tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map(column => ({
            RendaFixaCaracteristicasID: idCaracteristica,
            DataReferencia: toISODate(column.DataReferencia),
            PrecoConversao: toDecimal(column.PrecoConversao) ?? null,
            PremioConversao: toDecimal(column.PremioConversao) ?? null,
            DataInicioPreco: toISODate(column.DataInicioPreco),
            Ticker: column.Ticker || null,
            ConversaoFacultativa: toInt(column.ConversaoFacultativa) ?? 0,
            ConversaoMandatoria: toInt(column.ConversaoMandatoria) ?? 0,
            DataInicioConversao: toISODate(column.DataInicioConversao),
            DataFimConversao: toISODate(column.DataFimConversao),
            TipoPrecoConversao: column.TipoPrecoConversao || null,
            LimiteConversao: column.LimiteConversao || null,
            JanelaPregoes: toInt(column.JanelaPregoes) ?? 0,
            PercentualPregoes: toDecimal(column.PercentualPregoes) ?? null,
        }))

    return {
        Conversibilidades: conversibilidades,
    }
}

export const mapConversibilidadeToTable = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        ID: item.ID,
        RendaFixaCaracteristicasID: item.RendaFixaCaracteristicasID,
        CETIP: item.CETIP || "",
        VersaoDocumento: item.VersaoDocumento ?? 0,
        DataReferencia: formatDateBr(item.DataReferencia),
        PrecoConversao: item.PrecoConversao ?? 0,
        PremioConversao: item.PremioConversao ?? 0,
        DataInicioPreco: formatDateBr(item.DataInicioPreco),
        Ticker: item.Ticker || "",
        ConversaoFacultativa: item.ConversaoFacultativa ?? 0,
        ConversaoMandatoria: item.ConversaoMandatoria ?? 0,
        DataInicioConversao: formatDateBr(item.DataInicioConversao),
        DataFimConversao: formatDateBr(item.DataFimConversao),
        LimiteConversao: item.LimiteConversao ?? 0,
        TipoPrecoConversao: item.TipoPrecoConversao || "",
        JanelaPregoes: item.JanelaPregoes ?? 0,
        PercentualPregoes: item.PercentualPregoes ?? 0,
    }))
}
